
    import _Handlebars from 'handlebars/runtime';

    var Handlebars = _Handlebars.default;
    import "/home/canvas/public_html/ui/shared/external-tools/jst/_external_tools_menu.handlebars";
import "@canvas/i18n";
import "@canvas/handlebars-helpers/index.js";

    var template = Handlebars.template, templates = Handlebars.templates = Handlebars.templates || {};
    var name = '/home/canvas/public-html/ui/features/assignment-index/jst/AssignmentGroupListItem';
    templates[name] = template(function (Handlebars,depth0,helpers,partials,data) {
  this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Handlebars.helpers); partials = this.merge(partials, Handlebars.partials); data = data || {};
  var buffer = "", stack1, helper, options, helperMissing=helpers.helperMissing, escapeExpression=this.escapeExpression, functionType="function", self=this;

function program1(depth0,data) {
  
  
  return "\n      <span class=\"sortable-handle\">\n        <i class=\"icon-drag-handle\" aria-hidden=\"true\"></i>\n      </span>\n    ";
  }

function program3(depth0,data) {
  
  var buffer = "", stack1, helper;
  buffer += "\n      <h3 class=\"ig-header-title\">\n        <button\n        class=\"element_toggler accessible-toggler\"\n        aria-controls=\"assignment_group_";
  if (helper = helpers.id) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.id); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "_assignments\"\n        aria-expanded=\"true\"\n        aria-label=\"";
  if (helper = helpers.name) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.name); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + " ";
  if (helper = helpers.toggleMessage) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.toggleMessage); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\"\n        tabindex=\"0\"\n        >\n          <i class=\"icon-mini-arrow-down\"></i>\n          ";
  if (helper = helpers.name) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.name); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\n        </button>\n        ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.hasIntegrationData), {hash:{},inverse:self.noop,fn:self.program(4, program4, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n      </h3>\n    ";
  return buffer;
  }
function program4(depth0,data) {
  
  var buffer = "", helper, options;
  buffer += "\n          <i class=\"icon-sis-imported\" aria-hidden=\"true\" title='"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'postToSISName': ((depth0 && depth0.postToSISName)),
    'i18n_inferred_key': (true),
    'i18n_scope': ("assignments.assignment_group_list_item")
  },data:data},helper ? helper.call(depth0, "imported_from_posttosisname_f7cc9258", "Imported from %{postToSISName}", options) : helperMissing.call(depth0, "t", "imported_from_posttosisname_f7cc9258", "Imported from %{postToSISName}", options)))
    + "'></i>\n          <span class=\"screenreader-only\">"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'postToSISName': ((depth0 && depth0.postToSISName)),
    'i18n_inferred_key': (true),
    'i18n_scope': ("assignments.assignment_group_list_item")
  },data:data},helper ? helper.call(depth0, "imported_from_posttosisname_f7cc9258", "Imported from %{postToSISName}", options) : helperMissing.call(depth0, "t", "imported_from_posttosisname_f7cc9258", "Imported from %{postToSISName}", options)))
    + "</span>\n        ";
  return buffer;
  }

function program6(depth0,data) {
  
  var buffer = "", stack1, helper;
  buffer += "\n      <h2 class=\"ig-header-title\">\n        <button\n        class=\"element_toggler accessible-toggler\"\n        aria-controls=\"assignment_group_";
  if (helper = helpers.id) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.id); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "_assignments\"\n        aria-expanded=\"true\"\n        aria-label=\"";
  if (helper = helpers.name) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.name); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + " ";
  if (helper = helpers.toggleMessage) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.toggleMessage); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\"\n        tabindex=\"0\"\n        >\n          <i class=\"icon-mini-arrow-down\" aria-hidden=\"true\"></i>\n          ";
  if (helper = helpers.name) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.name); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\n        </button>\n        ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.hasIntegrationData), {hash:{},inverse:self.noop,fn:self.program(4, program4, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n      </h2>\n    ";
  return buffer;
  }

function program8(depth0,data) {
  
  var buffer = "", stack1;
  buffer += "\n        <ul class=\"pill\">\n          ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.showWeight), {hash:{},inverse:self.noop,fn:self.program(9, program9, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n          ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.showRules), {hash:{},inverse:self.noop,fn:self.program(11, program11, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n        </ul>\n      ";
  return buffer;
  }
function program9(depth0,data) {
  
  var buffer = "", stack1, helper, options;
  buffer += "\n            <li>";
  stack1 = (helper = helpers.n || (depth0 && depth0.n),options={hash:{
    'percentage': (true)
  },data:data},helper ? helper.call(depth0, (depth0 && depth0.groupWeight), options) : helperMissing.call(depth0, "n", (depth0 && depth0.groupWeight), options));
  buffer += escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'n_groupWeight_percentage': (stack1),
    'i18n_inferred_key': (true),
    'i18n_scope': ("assignments.assignment_group_list_item")
  },data:data},helper ? helper.call(depth0, "n_groupweight_percentage_of_total_2ae4d996", "%{n_groupWeight_percentage} of Total", options) : helperMissing.call(depth0, "t", "n_groupweight_percentage_of_total_2ae4d996", "%{n_groupWeight_percentage} of Total", options)))
    + "</li>\n          ";
  return buffer;
  }

function program11(depth0,data) {
  
  var buffer = "", stack1, helper, options;
  buffer += "\n            <li>\n              <a\n                href='#'\n                title='";
  stack1 = (helper = helpers.toSentence || (depth0 && depth0.toSentence),options={hash:{},inverse:self.noop,fn:self.program(12, program12, data),data:data},helper ? helper.call(depth0, (depth0 && depth0.displayableRules), options) : helperMissing.call(depth0, "toSentence", (depth0 && depth0.displayableRules), options));
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "'\n                class=\"tooltip_link\"\n                data-tooltip-selector=\"#ag_";
  if (helper = helpers.id) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.id); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "_rules_tooltip\"\n              >";
  if (helper = helpers.rulesText) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.rulesText); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "<i class=\"icon-mini-arrow-down\"></i></a>\n              <div id=\"ag_";
  if (helper = helpers.id) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.id); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "_rules_tooltip\" style=\"display:none;\">\n                ";
  stack1 = helpers.each.call(depth0, (depth0 && depth0.displayableRules), {hash:{},inverse:self.noop,fn:self.program(14, program14, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n              </div>\n            </li>\n          ";
  return buffer;
  }
function program12(depth0,data) {
  
  
  return escapeExpression((typeof depth0 === functionType ? depth0.apply(depth0) : depth0));
  }

function program14(depth0,data) {
  
  var buffer = "";
  buffer += "\n                  <span>"
    + escapeExpression((typeof depth0 === functionType ? depth0.apply(depth0) : depth0))
    + "</span><br/>\n                ";
  return buffer;
  }

function program16(depth0,data) {
  
  var buffer = "", helper, options;
  buffer += "\n        <a\n          href=\"#\"\n          class=\"add_assignment Button--icon-action\"\n          title='"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'name': ((depth0 && depth0.name)),
    'i18n_inferred_key': (true),
    'i18n_scope': ("assignments.assignment_group_list_item")
  },data:data},helper ? helper.call(depth0, "add_assignment_to_name_caf173b0", "Add Assignment to %{name}", options) : helperMissing.call(depth0, "t", "add_assignment_to_name_caf173b0", "Add Assignment to %{name}", options)))
    + "'\n        >\n          \n          <span class=\"screenreader-only\">"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'name': ((depth0 && depth0.name)),
    'i18n_inferred_key': (true),
    'i18n_scope': ("assignments.assignment_group_list_item")
  },data:data},helper ? helper.call(depth0, "add_assignment_to_name_caf173b0", "Add Assignment to %{name}", options) : helperMissing.call(depth0, "t", "add_assignment_to_name_caf173b0", "Add Assignment to %{name}", options)))
    + "</span>\n          <i class=\"icon-plus\"></i>\n        </a>\n      ";
  return buffer;
  }

function program18(depth0,data) {
  
  var buffer = "", stack1, helper, options;
  buffer += "\n        <div class=\"inline-block\">\n          <button id=\"ag_";
  if (helper = helpers.id) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.id); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "_manage_link\" class=\"al-trigger Button--icon-action\" tabindex=\"0\">\n            <span class=\"screenreader-only\">"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'name': ((depth0 && depth0.name)),
    'i18n_inferred_key': (true),
    'i18n_scope': ("assignments.assignment_group_list_item")
  },data:data},helper ? helper.call(depth0, "manage_name_7f55f792", "Manage %{name}", options) : helperMissing.call(depth0, "t", "manage_name_7f55f792", "Manage %{name}", options)))
    + "</span>\n            <i class=\"icon-more\" aria-hidden=\"true\"></i>\n          </button>\n          <ul class=\"al-options\">\n            ";
  stack1 = helpers['if'].call(depth0, ((stack1 = ((stack1 = (depth0 && depth0.ENV)),stack1 == null || stack1 === false ? stack1 : stack1.PERMISSIONS)),stack1 == null || stack1 === false ? stack1 : stack1.manage), {hash:{},inverse:self.noop,fn:self.program(19, program19, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n            ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.canDelete), {hash:{},inverse:self.program(23, program23, data),fn:self.program(21, program21, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n            ";
  stack1 = (helper = helpers.ifAll || (depth0 && depth0.ifAll),options={hash:{},inverse:self.noop,fn:self.program(25, program25, data),data:data},helper ? helper.call(depth0, ((stack1 = ((stack1 = (depth0 && depth0.ENV)),stack1 == null || stack1 === false ? stack1 : stack1.PERMISSIONS)),stack1 == null || stack1 === false ? stack1 : stack1.manage), (depth0 && depth0.canMove), options) : helperMissing.call(depth0, "ifAll", ((stack1 = ((stack1 = (depth0 && depth0.ENV)),stack1 == null || stack1 === false ? stack1 : stack1.PERMISSIONS)),stack1 == null || stack1 === false ? stack1 : stack1.manage), (depth0 && depth0.canMove), options));
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n            ";
  stack1 = helpers['if'].call(depth0, ((stack1 = ((stack1 = (depth0 && depth0.ENV)),stack1 == null || stack1 === false ? stack1 : stack1.PERMISSIONS)),stack1 == null || stack1 === false ? stack1 : stack1.manage), {hash:{},inverse:self.noop,fn:self.program(27, program27, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n          </ul>\n        </div>\n      ";
  return buffer;
  }
function program19(depth0,data) {
  
  var buffer = "", stack1, helper, options;
  buffer += "\n            <li>\n              <a\n                class=\"edit_group icon-edit\"\n                aria-label=\""
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true),
    'i18n_scope': ("assignments.assignment_group_list_item")
  },data:data},helper ? helper.call(depth0, "edit_assignment_group_c04c4af0", "Edit Assignment Group", options) : helperMissing.call(depth0, "t", "edit_assignment_group_c04c4af0", "Edit Assignment Group", options)))
    + "\"\n                data-focus-returns-to=\"ag_";
  if (helper = helpers.id) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.id); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "_manage_link\"\n              >"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true),
    'i18n_scope': ("assignments.assignment_group_list_item")
  },data:data},helper ? helper.call(depth0, "edit_c5fbea07", "Edit", options) : helperMissing.call(depth0, "t", "edit_c5fbea07", "Edit", options)))
    + "</a>\n            </li>\n            ";
  return buffer;
  }

function program21(depth0,data) {
  
  var buffer = "", stack1, helper, options;
  buffer += "\n            <li>\n              <a\n                class=\"delete_group icon-trash\"\n                aria-label='"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true),
    'i18n_scope': ("assignments.assignment_group_list_item")
  },data:data},helper ? helper.call(depth0, "delete_assignment_group_7c3b01c4", "Delete Assignment Group", options) : helperMissing.call(depth0, "t", "delete_assignment_group_7c3b01c4", "Delete Assignment Group", options)))
    + "'\n                data-focus-returns-to=\"ag_";
  if (helper = helpers.id) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.id); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "_manage_link\"\n              >"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true),
    'i18n_scope': ("assignments.assignment_group_list_item")
  },data:data},helper ? helper.call(depth0, "delete_a6efa79d", "Delete", options) : helperMissing.call(depth0, "t", "delete_a6efa79d", "Delete", options)))
    + "</a>\n            </li>\n            ";
  return buffer;
  }

function program23(depth0,data) {
  
  var buffer = "", helper, options;
  buffer += "\n            <li>\n              <a\n                class=\"delete_group icon-trash disabled\"\n                aria-label='"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true),
    'i18n_scope': ("assignments.assignment_group_list_item")
  },data:data},helper ? helper.call(depth0, "delete_assignment_group_7c3b01c4", "Delete Assignment Group", options) : helperMissing.call(depth0, "t", "delete_assignment_group_7c3b01c4", "Delete Assignment Group", options)))
    + "'\n                aria-disabled=true\n              >"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true),
    'i18n_scope': ("assignments.assignment_group_list_item")
  },data:data},helper ? helper.call(depth0, "delete_a6efa79d", "Delete", options) : helperMissing.call(depth0, "t", "delete_a6efa79d", "Delete", options)))
    + "</a>\n            </li>\n            ";
  return buffer;
  }

function program25(depth0,data) {
  
  var buffer = "", stack1, helper, options;
  buffer += "\n            <li>\n              <a\n                class=\"move_contents icon-move-down\"\n                aria-label='"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true),
    'i18n_scope': ("assignments.assignment_group_list_item")
  },data:data},helper ? helper.call(depth0, "move_assignment_contents_245c61bb", "Move Assignment Contents", options) : helperMissing.call(depth0, "t", "move_assignment_contents_245c61bb", "Move Assignment Contents", options)))
    + "'\n                data-focus-returns-to=\"ag_";
  if (helper = helpers.id) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.id); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "_manage_link\"\n              >"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true),
    'i18n_scope': ("assignments.assignment_group_list_item")
  },data:data},helper ? helper.call(depth0, "move_contents_29713356", "Move Contents…", options) : helperMissing.call(depth0, "t", "move_contents_29713356", "Move Contents…", options)))
    + "</a>\n            </li>\n            <li>\n              <a\n                class=\"move_group icon-updown\"\n                aria-label='"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true),
    'i18n_scope': ("assignments.assignment_group_list_item")
  },data:data},helper ? helper.call(depth0, "move_assignment_group_46e09fc3", "Move Assignment Group", options) : helperMissing.call(depth0, "t", "move_assignment_group_46e09fc3", "Move Assignment Group", options)))
    + "'\n                data-focus-returns-to=\"ag_";
  if (helper = helpers.id) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.id); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "_manage_link\"\n              >"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true),
    'i18n_scope': ("assignments.assignment_group_list_item")
  },data:data},helper ? helper.call(depth0, "move_group_77ae285d", "Move Group…", options) : helperMissing.call(depth0, "t", "move_group_77ae285d", "Move Group…", options)))
    + "</a>\n            </li>\n            ";
  return buffer;
  }

function program27(depth0,data) {
  
  var buffer = "", stack1;
  buffer += "\n              ";
  stack1 = self.invokePartial(partials['ui/shared/external-tools/jst/_external_tools_menu.handlebars'], 'ui/shared/external-tools/jst/_external_tools_menu.handlebars', (depth0 && depth0.assignmentGroupMenuPlacements), helpers, partials, data);
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n            ";
  return buffer;
  }

function program29(depth0,data) {
  
  
  return "\n    <form data-view=\"createAssignment\" class=\"form-dialog\"></form>\n  ";
  }

function program31(depth0,data) {
  
  
  return "\n    <form data-view=\"editAssignmentGroup\" class=\"form-dialog\"></form>\n  ";
  }

function program33(depth0,data) {
  
  
  return "\n    <form data-view=\"deleteAssignmentGroup\" class=\"form-dialog\"></form>\n  ";
  }

  buffer += "<div id=\"assignment_group_";
  if (helper = helpers.id) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.id); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\" data-id=\"";
  if (helper = helpers.id) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.id); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\" class=\"assignment_group\">\n\n  <div class=\"ig-header\">\n    ";
  stack1 = helpers['if'].call(depth0, ((stack1 = ((stack1 = (depth0 && depth0.ENV)),stack1 == null || stack1 === false ? stack1 : stack1.PERMISSIONS)),stack1 == null || stack1 === false ? stack1 : stack1.manage), {hash:{},inverse:self.noop,fn:self.program(1, program1, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n    ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.course_home), {hash:{},inverse:self.program(6, program6, data),fn:self.program(3, program3, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n\n    <div class=\"ag-header-controls\">\n      ";
  stack1 = (helper = helpers.ifAny || (depth0 && depth0.ifAny),options={hash:{},inverse:self.noop,fn:self.program(8, program8, data),data:data},helper ? helper.call(depth0, (depth0 && depth0.showWeight), (depth0 && depth0.showRules), options) : helperMissing.call(depth0, "ifAny", (depth0 && depth0.showWeight), (depth0 && depth0.showRules), options));
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n\n      ";
  stack1 = helpers['if'].call(depth0, ((stack1 = ((stack1 = (depth0 && depth0.ENV)),stack1 == null || stack1 === false ? stack1 : stack1.PERMISSIONS)),stack1 == null || stack1 === false ? stack1 : stack1.manage_assignments_add), {hash:{},inverse:self.noop,fn:self.program(16, program16, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n      ";
  stack1 = (helper = helpers.ifAny || (depth0 && depth0.ifAny),options={hash:{},inverse:self.noop,fn:self.program(18, program18, data),data:data},helper ? helper.call(depth0, ((stack1 = ((stack1 = (depth0 && depth0.ENV)),stack1 == null || stack1 === false ? stack1 : stack1.PERMISSIONS)),stack1 == null || stack1 === false ? stack1 : stack1.manage), (depth0 && depth0.canDelete), options) : helperMissing.call(depth0, "ifAny", ((stack1 = ((stack1 = (depth0 && depth0.ENV)),stack1 == null || stack1 === false ? stack1 : stack1.PERMISSIONS)),stack1 == null || stack1 === false ? stack1 : stack1.manage), (depth0 && depth0.canDelete), options));
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n    </div>\n  </div>\n\n  <div id=\"assignment_group_";
  if (helper = helpers.id) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.id); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "_assignments\" class=\"assignment-list\" >\n    <ul class=\"collectionViewItems ig-list draggable\"></ul>\n  </div>\n\n  ";
  stack1 = helpers['if'].call(depth0, ((stack1 = ((stack1 = (depth0 && depth0.ENV)),stack1 == null || stack1 === false ? stack1 : stack1.PERMISSIONS)),stack1 == null || stack1 === false ? stack1 : stack1.manage_assignments_add), {hash:{},inverse:self.noop,fn:self.program(29, program29, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n  ";
  stack1 = helpers['if'].call(depth0, ((stack1 = ((stack1 = (depth0 && depth0.ENV)),stack1 == null || stack1 === false ? stack1 : stack1.PERMISSIONS)),stack1 == null || stack1 === false ? stack1 : stack1.manage), {hash:{},inverse:self.noop,fn:self.program(31, program31, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n  ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.canDelete), {hash:{},inverse:self.noop,fn:self.program(33, program33, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n</div>\n";
  return buffer;
  });
    ;
    
    import brandableCss from '@canvas/brandable-css';

    brandableCss.loadStylesheetForJST({
      id: 'f0',
      bundle: 'jst/assignments/AssignmentGroupListItem'
    });
  ;
    export default templates[name];
  